import React, { useMemo, useRef } from 'react'
import { connect } from 'react-redux'
import { SubmissionError } from 'redux-form'
import QS from 'qs'
import { useTranslation } from 'react-i18next'

import { setCurrentUserToken } from 'ducks/users/index.ts'
import { authenticate, validateOtp } from 'utils/io'

import AuthPage from './AuthV2/AuthPage.tsx'

import './Auth.scss'
import TwoFactorAuthLoginForm from './AuthV2/TwoFactorAuthLoginForm'

const TwoFactorAuthLogin = props => {
  const { t } = useTranslation()
  const { location, history, setCurrentUserToken } = props

  const credentialsRef = useRef({ email: '', password: '' })

  useMemo(() => {
    const stored = localStorage.getItem('twoFactorData')
    if (!stored) {
      history.push('/login')

      return
    }

    try {
      credentialsRef.current = JSON.parse(stored)
      localStorage.removeItem('twoFactorData') // clean up
    } catch (err) {
      history.push('/login')
    }
  }, [])

  const redirect = useMemo(() => {
    const { redirect } = QS.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    return redirect
  }, [location])

  const handle2FASubmit = async ({ authCode }) => {
    try {
      const { email, password } = credentialsRef.current

      if (!email || !password) {
        throw new Error('Missing email and password')
      }

      const valid = await validateOtp({
        authCode,
        email,
      })

      if (valid) {
        const data = {
          authCode,
          email,
          password,
        }

        const { sessionToken, validateEmail } = await authenticate(data)

        setCurrentUserToken(sessionToken)

        //If they have an emailValidationString but no emailValidatedAt, send them to email validation page
        if (validateEmail) {
          history.push('/email-validation')
        } else {
          history.push(redirect || '/')
        }
      }
    } catch (err) {
      throw new SubmissionError({
        _error: err.message || t('Invalid authentication code'),
      })
    }
  }

  return (
    <AuthPage className="two-factor-auth" version={2}>
      <TwoFactorAuthLoginForm onSubmit={handle2FASubmit} redirect={redirect} />
    </AuthPage>
  )
}

export default connect(null, { setCurrentUserToken })(TwoFactorAuthLogin)
